"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Phone } from "lucide-react";
export default function ReadyToMove() {
  return <section data-section-id="235396" id="ready-to-move" className="dark bg-background text-foreground relative overflow-hidden py-20 px-4 sm:py-24">
      {}
      <div className="absolute inset-0 opacity-30">
        <svg className="w-full h-full" viewBox="0 0 1200 400" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <style>
              {`
                @keyframes ripple {
                  0% { d: path('M0,200 Q300,150 600,200 T1200,200 L1200,400 L0,400 Z'); }
                  50% { d: path('M0,180 Q300,130 600,180 T1200,180 L1200,400 L0,400 Z'); }
                  100% { d: path('M0,200 Q300,150 600,200 T1200,200 L1200,400 L0,400 Z'); }
                }
                .ripple-path {
                  animation: ripple 6s ease-in-out infinite;
                  fill: hsl(225 73% 45% / 0.15);
                }
              `}
            </style>
          </defs>
          <path className="ripple-path" d="M0,200 Q300,150 600,200 T1200,200 L1200,400 L0,400 Z" />
        </svg>
      </div>

      {}
      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center justify-center">
        {}
        <h2 className="font-default font-bold text-4xl sm:text-5xl md:text-6xl text-foreground mb-6 leading-tight tracking-tighter">
          Ready to find your new home?
        </h2>

        {}
        <Button className="mb-8 bg-primary hover:bg-primary/90 text-primary-foreground font-default font-bold text-lg px-8 py-4 h-auto rounded-md shadow-lg hover:shadow-xl transition-all duration-400 transform hover:scale-105" asChild>
          <Link to="/ScheduleAVisitPage">Schedule a Visit</Link>
        </Button>

        {}
        <div className="flex items-center justify-center gap-3">
          <Phone className="w-5 h-5 text-primary" />
          <Link to="tel:701-587-4715" className="text-lg font-default font-semibold text-foreground hover:text-primary transition-colors">
            701-587-4715
          </Link>
        </div>
      </div>
    </section>;
}